if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (this.engravingPending) return;
        const engraving = this.form.querySelector('.doma-engrave__input');
        const reminder = this.querySelector('[data-engraving-reminder]');
        if (engraving && !engraving.value.trim() && reminder && typeof reminder.showModal === 'function') {
          this.engravingPending = true;
          try {
            const value = await this.askEngraving(reminder);
            if (!this.isConnected) return;
            engraving.value = value;
            engraving.dispatchEvent(new Event('input', { bubbles: true }));
            engraving.dispatchEvent(new Event('change', { bubbles: true }));
          } finally {
            this.engravingPending = false;
          }
          if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      askEngraving(dialog) {
        return new Promise((resolve) => {
          const input = dialog.querySelector('[data-engraving-input]');
          const video = dialog.querySelector('video');
          let settled = false;
          const finish = (value) => {
            if (settled) return;
            settled = true;
            dialog.removeEventListener('click', onClick);
            dialog.removeEventListener('cancel', onCancel);
            dialog.removeEventListener('close', onClose);
            input.removeEventListener('keydown', onKey);
            if (video) video.pause();
            if (dialog.open) dialog.close();
            resolve(value);
          };
          const confirm = () => {
            if (!input.value.trim()) { input.setCustomValidity('Escreva o nome ou escolha continuar sem gravação.'); input.reportValidity(); return; }
            input.setCustomValidity('');
            finish(input.value.trim());
          };
          const onClick = (event) => {
            if (event.target.closest('[data-engraving-confirm]')) confirm();
            else if (event.target.closest('[data-engraving-skip]')) finish('');
          };
          const onCancel = (event) => { event.preventDefault(); finish(''); };
          const onClose = () => finish('');
          const onKey = (event) => { input.setCustomValidity(''); if (event.key === 'Enter') { event.preventDefault(); confirm(); } };
          input.value = '';
          input.setCustomValidity('');
          dialog.addEventListener('click', onClick);
          dialog.addEventListener('cancel', onCancel);
          dialog.addEventListener('close', onClose);
          input.addEventListener('keydown', onKey);
          try { dialog.showModal(); } catch { finish(''); return; }
          if (video) {
            if (!video.getAttribute('src')) video.src = video.dataset.src;
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
